export interface IProductModel {
    id: string;
    itemId: string;
    upc: string;
    name: string;
    price: number;
    quantity: number;
    qty: number;
    quantityOrder: number;
    image: string;
    unitOfMeasure: string;
    unitQuantity: string;
    pricePer: number;
    promoDescription: string;
    description: string;
    salesRank: number;
    aisleId: string;
    departmentName: string;
    aisleName: string;
    shelfName: string;
    showStrikeThrough: Boolean;
    offerText: string;
    promoDescriptionVal: string;
    offerComplete: boolean;
    isBOGO: boolean;
    comment: string;
    comments: string;
    substitutionValue: string;
    substitutionPreference: string;
    promoType: string;
    promoTitle: string;
    basePrice: number;
    restrictedValue: number;
    maxPurchaseQty: number;
    previousPurchaseQty: number;
    promoEndDate: string;
    promoText: string;
    inventoryAvailable: string;
    channelEligibility: object;
}

export interface ICouponModel {
    id: string;
    offerId: string;
    name: string;
    price: number;
    image: string;
    description: string;
    expiryDate: string;
    refineEndDate: string;
    offerComplete: boolean;
    brand: string;
    category: string;
    offerPrice: string;
    status: string;
    offerType: string;
    refineBrand: string;
    refineDescription: string;
    refineOfferPrice: string;
    regularPrice: string;
    usageTypeTxt: string;
    usageType: string;
    offerPgmLabel: string;
    imageId: string;
    couponID: string;
    summary?: string;
    events?: string[];
}

export interface IDealModel {
    id: string;
    title: string;
    description: string;
    promo: string;
    image: string;
    expiryDate: string;
    brand: string;
    category: string;
    status: string;
}

export class DealModel implements IDealModel {
    id: string;
    title: string;
    description: string;
    promo: string;
    image: string;
    expiryDate: string;
    brand: string;
    category: string;
    status: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IDealUpdateModel {
    id: string;
    title: string;
    description: string;
    promo: string;
}

export class DealUpdateModel implements IDealUpdateModel {
    public id: string;
    public title: string;
    public description: string;
    public promo: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class CouponModel implements ICouponModel {
    public id: string;
    public offerId: string;
    public name: string;
    public price: number;
    public image: string;
    public description: string;
    public expiryDate: string;
    public updBtnText: string = 'Added';
    public updBtnMode: Boolean = true;
    public brand: string;
    public category: string;
    public offerPrice: string = '';
    public status: string;
    public deleted: boolean;
    public offerType: string;
    public offerTs: string;
    public endDate: string;
    public offerPgm: string;
    public refineBrand: string;
    public refineDescription: string;
    public refineOfferPrice: string;
    public refineEndDate: string;
    public offerComplete: boolean;
    public regularPrice: string;
    public usageTypeTxt: string;
    public usageType: string;
    public offerPgmLabel: string;
    public imageId: string;
    public couponID: string;
    public summary?: string;
    public priceTitle?: string;
    public events?: string[];
    public logoSVGCouponCarouseImageEnable?: boolean = false;
    public logoSVGCouponCarouseImage?: string = '';

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface ICouponUpdateModel {
    id: string;
    price: number;
    offerId: string;
    offerPrice: string;
}

export class CouponUpdateModel implements ICouponUpdateModel {
    public id: string;
    public price: number;
    public offerId: string;
    public offerPrice: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class ProductModel implements IProductModel {
    public id: string;
    itemId: string;
    public upc: string;
    public name: string;
    public price: number;
    public quantity: number;
    public qty: number;
    public quantityOrder: number;
    public image: string;
    public unitOfMeasure: string;
    public unitQuantity: string;
    public pricePer: number;
    public promoDescription: string;
    public description: string;
    public salesRank: number;
    public aisleId: string;
    public departmentName: string;
    public aisleName: string;
    public shelfName: string;
    public updBtnText: string = 'Update';
    public updBtnMode: Boolean = true;
    public showStrikeThrough: Boolean;
    public offerText: string;
    public promoDescriptionVal: string;
    public offerComplete: boolean;
    public isBOGO: boolean;
    public comment: string;
    public comments: string;
    public substitutionValue: string;
    public substitutionPreference: string;
    public promoType: string;
    public promoTitle: string;
    public basePrice: number;
    public restrictedValue: number;
    public maxPurchaseQty: number;
    public previousPurchaseQty: number;
    public promoEndDate: string;
    public promoText: string;
    public inventoryAvailable: string;
    public channelEligibility: object;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IProductUpdateModel {
    id: string;
    price: number;
    comment: string;
    substitutionValue: string;
    quantity: number;
}

export class ProductUpdateModel implements IProductUpdateModel {
    public id: string;
    public price: number;
    public comment: string;
    public substitutionValue: string;
    public quantity: number;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IFilter {
    id: string;
    label: any;
}

export class FilterModel implements IFilter {
    public id: string;
    public label: any;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface ISortRule {
    field: string;
    direction: number;
    type: string;
    callback?: (a: ProductModel, s: SortModel) => void;
}

export interface ISort {
    field: string;
    rule: ISortRule[];
    label: any;
    selected?: Boolean;
    sort_at: string;
}

export class SortModel implements ISort {
    public field: string;
    public label: any;
    public rule: ISortRule[];
    public selected?: Boolean;
    public sort_at: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class DepartmentModel implements IFilter {
    public id: string;
    public label: any;
    public aisle: string[];

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class BrandModel implements IFilter {
    public id: string;
    public label: any;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface LoaderState {
    show: boolean;
}

export interface ICarousel {
    type: String;
    behaviour: String;
    userRestrictions: String;
    dataSource: any;
    apiPostBody: any;
    actionButton: String;
}

export class CarouselModel implements ICarousel {
    public type: String;
    public behaviour: String;
    public userRestrictions: String;
    public dataSource: any;
    public title: String;
    public apiPostBody: any;
    public actionButton: String;
    public aisleName: String;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface ICouponCarousel {
    carouselSource: String;
    carouselFilter: String;
    carouselOfferLimit: Number;
}

export class CouponCarouselModel implements ICouponCarousel {
    public carouselSource: String;
    public carouselFilter: String;
    public carouselOfferLimit: number;
    public errorMessage: string;
    public carouselTitle: String;
    public carouselLinkLabel: String;
    public carouselLinkPath: String;
    public offerCarouselApiBased: boolean;
    public upc: string;
    public includePageName: String = '';
    public odpOfferId: string;
    public logoSVGCouponCarouseImageEnable?: boolean = false;
    public logoSVGCouponCarouseImage?: string = '';

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IDealCarousel {
    // To be added
}

export class DealCarouselModel implements IDealCarousel {
    // To be added
    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IOfferDetail {
    offerId: string;
}

export class OfferDetail implements IOfferDetail {
    public offerId: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IRewardDetail {
    rewardId: string;
}

export class RewardDetail implements IRewardDetail {
    public rewardId: string;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export interface IRewardModel {
    offerPrice: string;
    description: string;
    image: string;
    status: string;
    startDate: string;
    endDate: string;
    offerTs: string;
    pointsRequired: number;
    usageType: string;
    offerPgm: string;
    purchaseInd: string;
    groceryRewardId: string;
    title: string;
    rewardsRequired: number;
    rewardsAvailable: number;
    generalDisclaimer: string;
    category: string;
    specialRank: number;
    displayStartDate: string;
    displayEndDate: string;
    detailPath: string;
    isConfirmModalButtonDisabled: boolean;
    rewardsRefundable: boolean;
    clipId: string;
    clipDetails: {
        redeemed: Array<string>;
        clipped: Array<string>;
        redeemedCount: number;
        clippedCount: number;
        totalClippedCount: number;
        multiClipLimit: number;
    };
}

export class RewardModel implements IRewardModel {
    offerPrice: string;
    description: string;
    image: string;
    imageId: string;
    status: string;
    startDate: string;
    endDate: string;
    offerTs: string;
    usageType: string;
    offerPgm: string;
    offerProtoType: string;
    purchaseInd: string;
    programType: string;
    groceryRewardId: string;
    offerId: string;
    title: string;
    rewardsRequired: number;
    pointsOrRewardsRequired?: number;
    rewardsAvailable: number;
    rewardsExpire: number;
    generalDisclaimer: string;
    pointsRequired: number;
    category: string;
    specialRank: number;
    displayStartDate: string;
    displayEndDate: string;
    detailPath: string;
    isConfirmModalButtonDisabled: boolean;
    rewardsRefundable: boolean;
    clipId: string;
    upcList: any;
    clipDetails: {
        redeemed: Array<string>;
        clipped: Array<string>;
        redeemedCount: number;
        clippedCount: number;
        totalClippedCount: number;
        multiClipLimit: number;
    };
    pointsAvailable: number;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class RedeemedReward {
    offerId: string;
    description: string;
}

export class TransactionHistoryModel {

    date: string;
    eventSource: string;
    eventTs: string;
    activity: {
        type: string;  // earn | burn
        points: string;
        rewards: string;
    };
    totalBalance: {
        points: string;
        rewards: string;
    };

    receiptInfo?: {
        date: string;
        store: string;
        lane: string;
        transactionNbr: string;
    };
    clippedReward?: {
        offerId: string;
        externalOfferId: string;
        description: string;
    };
    reclaimedReward?: {
        offerId: '',
        extOfferId: '',
        clipId: '',
        description: '',
    };
    redeemedRewards?: RedeemedReward[];
    gasRewards?: {
        partner: string;
        discountPerGallon: string;
    };
}

export class RewardHistoryModel {
    hhid: string;
    transactionHistories: TransactionHistoryModel[];
    pageable?: {
        empty: boolean;
        first: boolean;
        last: boolean;
        offset: number;
        pageNumber: number;
        pageSize: number;
        paged: boolean;
        sorted: boolean;
        totalElements: number;
        totalPages: number;
    };
}

export interface IUnclipRewardDetailModel {
    clipId: string;
    expiredRewards: number;
    hhid: string;
    isPartiallyExpired: boolean;
    isValidForUnClip: boolean;
    totalClippedRewards: number;
    totalClippedPoints: number;
    expiredPoints: number;
}

export class UnclipRewardDetailModel implements IUnclipRewardDetailModel {
    clipId: string;
    expiredRewards: number;
    hhid: string;
    isPartiallyExpired: boolean;
    isValidForUnClip: boolean;
    totalClippedRewards: number;
    totalClippedPoints: number;
    expiredPoints: number;

    constructor(data?: any) {
        Object.assign(this, data);
    }
}

export class UnclipRewardModel {
    clipType: string;
    itemId: string;
    itemType: string;
    status: number;
    clipId: string;
    faultCode: {
        code: string;
        description: string;
    };
    checked: boolean;
    errorCd = '';
    errorMsg = '';

    constructor(data?: any) {
        Object.assign(this, data);
    }
}
